import {Box} from '@mui/material';
import {StyledGrid} from 'presentation/components';
import {Loading} from 'presentation/components/Loading/Loading';
import {PaidBilletCard} from 'presentation/components/PaidBilletCard';
import {QueryParamsEnum} from 'presentation/constants';
import {ErrorBills} from 'presentation/pages/private/my-payments-flow/components/ErrorBills';
import {useHostName} from 'presentation/hooks';
import {translations} from 'presentation/translations-new';
import React, {useEffect} from 'react';
import {Container} from '../../../../styles';
import {CardEmpty} from '../../../components';
import SearchEmptyBigSvg from '../../../components/CardEmpty/svgr/SearchEmptyBigSvg';
import {usePaymentsHistory} from '../../hooks/usePaymentsHistory';

const {emptyCardBillsTitle, emptyCardBillsDescription, emptyCardBillsDescriptionNotredameSaude} =
	translations['pt-br'].privateFlow.myFinancial.paymentsHistory;

function HistoryList() {
	const {isNotredameSaude} = useHostName();
	const {
		formattedYear,
		paymentsLoading,
		paymentsHasError,
		paymentsHistoryData,
		handleTryAgain,
		SEARCH_PARAMS,
		setSearchParams,
		isEmpty,
	} = usePaymentsHistory();
	const {year} = SEARCH_PARAMS;

	useEffect(() => {
		setSearchParams(
			prev => {
				prev.set(QueryParamsEnum.YEAR, String(formattedYear));
				return prev;
			},
			{replace: true},
		);
	}, [year]);

	if (paymentsLoading) {
		return <Loading minHeight="60vh" />;
	}

	if (paymentsHasError) {
		return <ErrorBills handleTryAgain={handleTryAgain} />;
	}

	return (
		<Container>
			{isEmpty ? (
				<Box marginTop={5}>
					<CardEmpty title={emptyCardBillsTitle} illustration={<SearchEmptyBigSvg />}>
						{isNotredameSaude
							? emptyCardBillsDescriptionNotredameSaude
							: emptyCardBillsDescription}
					</CardEmpty>
				</Box>
			) : (
				<StyledGrid.Root>
					{paymentsHistoryData?.map((payment, index) => (
						<StyledGrid.Item key={index}>
							<PaidBilletCard billet={payment} year={year} />
						</StyledGrid.Item>
					))}
				</StyledGrid.Root>
			)}
		</Container>
	);
}

export {HistoryList};
